import {
    createEntityAdapter,
    EntityAdapter,
    EntityState
} from '@ngrx/entity';
import { IDatiqFeatureFlag } from '../models';

/**
 * Interface for the 'DatiqFeatureFlag' data
 */
export interface IDatiqFeatureFlagEntity extends IDatiqFeatureFlag {}

export const DATIQ_FEATURE_FLAG_FEATURE_KEY = 'datiqFeatureFlag';

export interface State extends EntityState<IDatiqFeatureFlagEntity> {
    selectedId?: string | number; // which DatiqFeatureFlag record has been selected
    loaded: boolean; // has the DatiqFeatureFlag list been loaded
    error?: string | null; // last known error (if any)
    useFlags: boolean; //If true, then it will use flags for feature toggling
}

export interface DatiqFeatureFlagPartialState {
    readonly [DATIQ_FEATURE_FLAG_FEATURE_KEY]: State;
}

export const datiqFeatureFlagAdapter: EntityAdapter<IDatiqFeatureFlagEntity> = createEntityAdapter<
    IDatiqFeatureFlagEntity
>();

export const initialState: State = datiqFeatureFlagAdapter.getInitialState({
    // set initial required properties
    loaded: false,
    useFlags: false,
});
